import {
  LitElement,
  html,
  css,
  t,
  styles,
  classMap,
  utils,
  broadcastReceiver,
} from '@hh/global.js'

class HHProductInventory extends LitElement {
  static properties = {
    sectionId: {
      type: String,
      attribute: 'section-id',
    },
    initialVariant: {
      type: Object,
      attribute: 'init-variant',
      converter(value) {
        return JSON.parse(utils.decode(value))
      },
    },
    currentVariant: {
      type: Object,
    },
    quantity: {
      type: Number,
      default: 1,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    window.addEventListener('variant:change', this.onVariantChange.bind(this))
    super.connectedCallback()

    this.currentVariant = this.initialVariant
    this.quantity = 1

    this.checkAvailability()

    this.receiver = broadcastReceiver('quantity', (...args) => {
      this.getQuantityFromDocument(...args)
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.receiver && this.receiver.disconnect()
    window.removeEventListener('variant:change', this.onVariantChange)
  }

  getQuantityFromDocument(data) {
    this.quantity = data.value || 1

    this.checkAvailability()
  }

  onVariantChange(e) {
    const { variant } = e.detail

    this.currentVariant = variant

    this.checkAvailability()
  }

  get trackingQuantity() {
    return (
      this.currentVariant.inventory_policy === 'deny' &&
      this.currentVariant.inventory_management === 'shopify'
    )
  }

  get quantityOverflow() {
    return (
      this.quantity > this.currentVariant.inventory_quantity &&
      this.trackingQuantity
    )
  }

  get inventoryMessage() {
    return t(
      `products.product.inventory_availability.${this.quantityOverflow ? 'not_available' : 'available'}`
    ).replace('{{ quantity }}', this.currentVariant.inventory_quantity)
  }

  checkAvailability() {
    if (!this.trackingQuantity) return

    document
      .getElementById(`product-form-${this.sectionId}`)
      .querySelectorAll(
        '[name="add"], .js-personalize-button, k2-customizer2026'
      )
      .forEach((button) => {
        this.quantityOverflow
          ? button.setAttribute('disabled', true)
          : button.removeAttribute('disabled')
      })
  }

  createRenderRoot() {
    return this
  }

  render() {
    return html`
      ${this.currentVariant.available && this.trackingQuantity
        ? html`
            <p
              class="${classMap({
                'c-error': this.quantityOverflow,
              })}"
            >
              ${this.inventoryMessage}
            </p>
          `
        : ''}
    `
  }

  static styles = [styles.visuallyHidden, css``]
}

customElements.define('hh-product-inventory', HHProductInventory)
